import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { FieldsWrapper, Field } from './index.styles';
import _ from 'lodash';
import {ButtonsGroup, PaperStyled} from '../../index.styles';

const PersonalInfoSkeleton = () => {
  return (
    <>
      <PaperStyled>
        <FieldsWrapper>
          {_.times(27, (index) => (
            <Field key={index}>
              <span className="title">
                <Skeleton width={170} />
              </span>
              <span className="value">
                <Skeleton />
              </span>
            </Field>
          ))}
        </FieldsWrapper>
      </PaperStyled>
      <ButtonsGroup>
        <Skeleton variant="rect" width={120} height={42} />
        <Skeleton variant="rect" width={120} height={42} />
        <Skeleton variant="rect" width={120} height={42} />
      </ButtonsGroup>
    </>
  );
};

export default PersonalInfoSkeleton;
